// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 550px;
}
.login-page .login-container {
  text-align: center;
}
.login-page .login-container h2 {
  font-size: 18px;
  margin-bottom: 10px;
}
.login-page .login-container .subtext {
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}
.login-page .login-container .login-form .form-group {
  margin-bottom: 20px;
  text-align: left;
}
.login-page .login-container .login-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-family: BoldFont;
  color: #333;
}
.login-page .login-container .login-form .form-group input {
  width: calc(100% - 17px);
  padding: 10px;
  border: 1px solid #ddd;
  background-color: rgba(188, 187, 193, 0.2);
  border-radius: 10px;
  font-size: 14px;
}
.login-page .login-container .login-form .form-group .password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.login-page .login-container .login-form .form-group .password-input-container input {
  width: calc(100% - 17px);
  padding: 10px 40px 10px 10px;
  border: 1px solid #ddd;
  background-color: rgba(188, 187, 193, 0.2);
  border-radius: 10px;
  font-size: 14px;
}
.login-page .login-container .login-form .form-group .password-input-container .password-toggle-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.login-page .login-container .login-form .form-group .password-input-container .password-toggle-btn:hover {
  color: #800080;
}
.login-page .login-container .login-form .form-group .password-input-container .password-toggle-btn:focus {
  outline: none;
}
.login-page .login-container .login-form .forgot-password {
  text-align: right;
  margin-bottom: 20px;
}
.login-page .login-container .login-form .forgot-password p {
  color: #800080; /* Purple color for the link */
  text-decoration: none;
}
.login-page .login-container .login-form .forgot-password p:hover {
  text-decoration: underline;
}
.login-page .login-container .login-form .login-button {
  width: 100%;
  padding: 12px;
  background-color: var(--pmu-primary); /* Purple color for the button */
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.login-page .login-container .login-form .login-button:hover {
  background-color: rgb(103.2727272727, 32.7272727273, 103.2727272727);
}

@media screen and (max-width: 768px) {
  .login-page {
    width: 100%;
  }
  .login-page .login-container h2 {
    font-size: 16px;
  }
  .login-page .login-container .subtext {
    font-size: 12px;
    margin-bottom: 20px;
  }
  .login-page .login-container .login-form .form-group label {
    font-size: 12px;
  }
  .login-page .login-container .login-form .form-group input {
    padding: 8px;
    font-size: 16px;
  }
  .login-page .login-container .login-form .forgot-password p {
    font-size: 12px;
  }
  .login-page .login-container .login-form .login-button {
    font-size: 14px;
  }
}
input[type=email],
input[type=password],
input[type=text] {
  font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/authpage/authsubfolders/login/login.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;AACN;AAEI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAAN;AAIM;EACE,mBAAA;EACA,gBAAA;AAFR;AAIQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAFV;AAKQ;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;AAHV;AAMQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAJV;AAMU;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;AAJZ;AAOU;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AALZ;AAOY;EACE,cAAA;AALd;AAQY;EACE,aAAA;AANd;AAYM;EACE,iBAAA;EACA,mBAAA;AAVR;AAYQ;EACE,cAAA,EAAA,8BAAA;EACA,qBAAA;AAVV;AAYU;EACE,0BAAA;AAVZ;AAeM;EACE,WAAA;EACA,aAAA;EACA,oCAAA,EAAA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAbR;AAeQ;EACE,oEAAA;AAbV;;AAoBA;EACE;IACE,WAAA;EAjBF;EAmBI;IACE,eAAA;EAjBN;EAoBI;IACE,eAAA;IACA,mBAAA;EAlBN;EAuBQ;IACE,eAAA;EArBV;EAwBQ;IACE,YAAA;IACA,eAAA;EAtBV;EA2BQ;IACE,eAAA;EAzBV;EA6BM;IACE,eAAA;EA3BR;AACF;AAiCA;;;EAGE,0BAAA;AA/BF","sourcesContent":[".login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 550px;\n\n  .login-container {\n    text-align: center;\n\n    h2 {\n      font-size: 18px;\n      margin-bottom: 10px;\n    }\n\n    .subtext {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 30px;\n    }\n\n    .login-form {\n      .form-group {\n        margin-bottom: 20px;\n        text-align: left;\n\n        label {\n          display: block;\n          margin-bottom: 8px;\n          font-size: 14px;\n          font-family: BoldFont;\n          color: #333;\n        }\n\n        input {\n          width: calc(100% - 17px);\n          padding: 10px;\n          border: 1px solid #ddd;\n          background-color: #bcbbc133;\n          border-radius: 10px;\n          font-size: 14px;\n        }\n\n        .password-input-container {\n          position: relative;\n          display: flex;\n          align-items: center;\n\n          input {\n            width: calc(100% - 17px);\n            padding: 10px 40px 10px 10px;\n            border: 1px solid #ddd;\n            background-color: #bcbbc133;\n            border-radius: 10px;\n            font-size: 14px;\n          }\n\n          .password-toggle-btn {\n            position: absolute;\n            right: 10px;\n            background: none;\n            border: none;\n            cursor: pointer;\n            color: #666;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 5px;\n\n            &:hover {\n              color: #800080;\n            }\n\n            &:focus {\n              outline: none;\n            }\n          }\n        }\n      }\n\n      .forgot-password {\n        text-align: right;\n        margin-bottom: 20px;\n\n        p {\n          color: #800080; /* Purple color for the link */\n          text-decoration: none;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .login-button {\n        width: 100%;\n        padding: 12px;\n        background-color: var(--pmu-primary); /* Purple color for the button */\n        color: #fff;\n        border: none;\n        border-radius: 10px;\n        font-size: 16px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n\n        &:hover {\n          background-color: darken(#8e2d8e, 10%);\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .login-page {\n    width: 100%;\n    .login-container {\n      h2 {\n        font-size: 16px;\n      }\n\n      .subtext {\n        font-size: 12px;\n        margin-bottom: 20px;\n      }\n\n      .login-form {\n        .form-group {\n          label {\n            font-size: 12px;\n          }\n\n          input {\n            padding: 8px;\n            font-size: 16px;\n          }\n        }\n\n        .forgot-password {\n          p {\n            font-size: 12px;\n          }\n        }\n\n        .login-button {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"text\"] {\n  font-size: 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
